import { useState } from "react";
import { movies } from "@/mocks/movies";
import { sortMovies } from "@/utils/movies";
import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/feature/SectionHeading";

const STEP = 6;
const tvList = sortMovies(
  movies.filter((m) => m.type === "tv"),
  "latest"
);

export default function TvUpdates() {
  const [visible, setVisible] = useState(6);
  const list = tvList.slice(0, visible);

  return (
    <section className="px-4 md:px-8 py-10">
      <SectionHeading
        title="最新剧集更新"
        subtitle="热播剧集同步追更，剧集进度一目了然"
        moreTo="/category/tv"
        moreLabel="全部电视剧"
      />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 md:gap-5">
        {list.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
      {visible < tvList.length && (
        <div className="flex justify-center mt-8">
          <button
            type="button"
            onClick={() => setVisible((v) => v + STEP)}
            className="flex items-center gap-2 px-6 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm font-label text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-add-line text-base"></i>
            </span>
            加载更多
          </button>
        </div>
      )}
    </section>
  );
}